// Shared Google Maps JS bootstrap loader. Loads the Maps JavaScript API (with the
// places library) exactly once and resolves when google.maps.importLibrary is ready.
// Used by the address autocomplete (PlaceAutocompleteElement, Places API New) on the
// signup form and the admin matchmaking console.

const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

export function loadMapsScript() {
  return new Promise((resolve, reject) => {
    if (window.google?.maps?.importLibrary) return resolve();
    const id = "google-maps-script";
    const existing = document.getElementById(id);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }
    const s = document.createElement("script");
    s.id = id;
    s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places&loading=async`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = reject;
    document.head.appendChild(s);
  });
}
